import React from "react";
import "../../App.css";
import { TabTitle } from "../../utils/GeneralFunctions";

export default function Services() {
  TabTitle("Services-TRVLR");
  return <h1 className="services">SERVICES</h1>;
}
